module.exports = __webpack_public_path__ + "3e9b4f463dc05626dd9f221ca663f5a0.svg";